import {createSvgIcon} from '../create-svg-icon';

export const ArrowForwardIosIcon = createSvgIcon(
  <path d="M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z" />
, 'ArrowForwardIosOutlined');
